import { getMadrakInfo, getMadrakHistory } from '@/api/madrak'
export default {
    state: {
        madrakInfo: {},
        history: [],


    },

    mutations: {

        SET_MADRAK_INFO: (state, data) => {
            state.madrakInfo = data
        },
        SET_MADRAK_HISTORY: (state, data) => {
            state.history = data
        },


    },

    actions: {
        getMadrakInfo({ commit }) {

            return new Promise((resolve, reject) => {
                getMadrakInfo().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_MADRAK_INFO', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getMadrakHistory({ commit }) {
            commit('SET_TABLE_TEXT', true)
            return new Promise((resolve, reject) => {
                getMadrakHistory().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_MADRAK_HISTORY', data)
                    commit('SET_TABLE_TEXT', false)

                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },

    }
}